<template>
  <div class="flex component-wrapper">
    <div class="items-center hidden md:flex">
      <div class="navigation left-navigation mr-2" :style="showBackward ? 'opacity: 1' : 'opacity: 0'" role="button" aria-label="Voir les produits précédents" @click="scrollBackward">
        <img style="width: 12px;transform: rotate(90deg)" src="../../assets/icons/nav-select-down.svg?img" alt="Précédent">
      </div>
    </div>
    <div ref="scrollable" class="flex overflow-y-auto flex-1 scrollable-wrapper">
      <div v-for="(p, index) in products" :key="p.sku" class="product-card-wrapper">
        <product-card
          :product="p"
          :position="index + 1"
          :list-name="listName"
        />
      </div>
    </div>
    <div class="items-center hidden md:flex">
      <div class="navigation right-navigation ml-4" :style="showForward ? 'opacity: 1' : 'opacity: 0'" role="button" aria-label="Voir les produits suivants" @click="scrollForward">
        <img style="width: 12px;transform: rotate(-90deg)" src="../../assets/icons/nav-select-down.svg?img" alt="Suivant">
      </div>
    </div>
  </div>
</template>

<script>
import ProductCard from '../general/ProductCard'

export default {
  components: {
    ProductCard
  },
  props: {
    products: {
      required: true,
      type: Array
    },
    listName: {
      required: false,
      type: String,
      default: undefined
    }
  },
  data () {
    return {
      showBackward: false,
      showForward: true
    }
  },
  mounted () {
    this.$refs.scrollable.onscroll = () => {
      this.showBackward = this.$refs.scrollable.scrollLeft !== 0

      this.showForward = this.$refs.scrollable.clientWidth + this.$refs.scrollable.scrollLeft !== this.$refs.scrollable.scrollWidth
    }

    this.showForward = this.$refs.scrollable.clientWidth + this.$refs.scrollable.scrollLeft !== this.$refs.scrollable.scrollWidth
  },
  methods: {
    scrollForward () {
      this.$refs.scrollable.scrollTo({
        left: this.$refs.scrollable.scrollLeft + 600,
        behavior: 'smooth'
      })
    },
    scrollBackward () {
      this.$refs.scrollable.scrollTo({
        left: this.$refs.scrollable.scrollLeft - 600,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .navigation {
    width: 44px;
    height: 44px;
    @apply border rounded-full flex items-center justify-center cursor-pointer;
  }
  .scrollable-wrapper {
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;  /* IE 10+ */
    &::-webkit-scrollbar {
      width: 0px;
      background: transparent; /* make scrollbar transparent */
    }
  }
  .product-card-wrapper {
    @apply px-3;
    max-width: 303px;
    @screen xl {
      min-width: 303px;
    }
  }
  .component-wrapper {
    @screen xl {
      margin: 0 -70px;
    }
  }
</style>
